import { Observable } from "rxjs"

export class EventBus {
  private eventMap = {}
  constructor() {}

  on(eventName: string, callback: Function) {
    const eventCallbacks = this.eventMap[eventName];
    if (eventCallbacks) {
      eventCallbacks.push(callback)
    } else {
      this.eventMap[eventName] = [callback]
    }
  }

  trigger(eventName: string, data: any) {
    const eventCallbacks = this.eventMap[eventName];
    if (eventCallbacks) {
      eventCallbacks.forEach(item => {
        item(data)
      })
    }
  }

  off(eventName: string, callback?: Function) {
    const eventCallbacks = this.eventMap[eventName];
    if (!callback) {
      delete this.eventMap[eventName]
      return
    }
    if (eventCallbacks) {
      this.eventMap[eventName] = eventCallbacks.filter(item => item !== callback)
    }
  }

  on$(eventName: string) {
    return new Observable((observer) => {
      const callback = (data) => {
        observer.next(data)
      }
      this.on(eventName, callback)

      return () => {
        this.off(eventName, callback)
      }
    })
  }
}